import { Component, EventEmitter, Output } from "@angular/core";

@Component({
  selector: "evrideo-content-control-studio-action-button",
  templateUrl: "./content-control-studio-action-button.component.html",
  styleUrl: "./content-control-studio-action-button.component.scss",
})
export class ContentControlStudioActionButtonComponent {
  @Output() buttonClicked: EventEmitter<void> = new EventEmitter<void>();

  clicked() {
    this.buttonClicked.emit();
  }
}
